import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const SearchService = {
  getSearchResults: async ({ email, contact, name, pageNo, pageSize }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.SEARCH.SEARCHCANDIDATES, {
      email,
      contact,
      name,
      pageNo,
      pageSize,
    });

    const response = await api.get(endpoint);
    return response;
  },

  suggestCandidates: async ({ name, limit = 10 }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.SEARCH.SUGGESTCANDIDATES, {
      name,
      limit,
    });
    const response = await api.get(endpoint);
    return response;
  },

  getCandidateDetails: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.SEARCH.GETCANDIDATEDETAILS, {
      id,
    });
    const response = await api.get(endpoint);
    return response;
  },
};
